import { render, staticRenderFns } from "./RouteStack.vue?vue&type=template&id=4dd80072&scoped=true"
import script from "./RouteStack.vue?vue&type=script&lang=js"
export * from "./RouteStack.vue?vue&type=script&lang=js"
import style0 from "./RouteStack.vue?vue&type=style&index=0&id=4dd80072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd80072",
  null
  
)

export default component.exports